import { useState, useEffect } from "react";
import * as yup from 'yup';
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { yupResolver } from '@hookform/resolvers/yup';
import { generalAccountConnectUber } from "redux/actions/providers";


const providerEmailSchema = yup.object().shape({
	generalAccountEmail: yup.string().email('Email is not valid').nullable(),
});

const useProviderEmail = (generalAccountEmail) => {
  const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
	
	const providerEmailForm = useForm({
		defaultValues: { generalAccountEmail: '' },
		resolver: yupResolver(providerEmailSchema),
	  mode: 'all',
	});
	
	const handleProviderEmailForm = async (values) => {
    setLoading(true);
    try {
      dispatch(generalAccountConnectUber({
        provider: 'ubereats',
        generalAccountEmail: values.generalAccountEmail,
      }));
      const { generalAccountEmail } = values;
      providerEmailForm.reset({
        generalAccountEmail
      });
    } catch (error) {
      console.error('Failed to connect Uber account:', error);
    } finally {
      setIsDirty(false);
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }; 

  useEffect(() => {
    if (generalAccountEmail) {
      providerEmailForm.setValue('generalAccountEmail', generalAccountEmail);
    }
  }, [generalAccountEmail]);

  const handleChange = (e) => {
    setIsDirty(true);
    providerEmailForm.setValue('generalAccountEmail', e.target.value, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return { providerEmailForm, handleProviderEmailForm, loading, handleChange, isDirty };
};

export default useProviderEmail;
